(function () {
  // Format a YYYY-MM-DD date string for Australian locale without timezone offset.
  function formatArrivalDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function updatePreOrderUI(variantId) {
    var backorder = window.product && window.product.backorder && window.product.backorder[variantId];
    var arrivalDate = window.product && window.product.arrivalDate && window.product.arrivalDate[variantId];

    // Update pre-order badge(s) — there may be more than one section on the page.
    document.querySelectorAll('[id^="pre-order-badge-"]').forEach(function (badge) {
      var sectionId = badge.id.replace('pre-order-badge-', '');

      badge.classList.toggle('hide', !backorder);

      var arrivalEl = document.getElementById('pre-order-arrival-' + sectionId);
      var wrapperEl = document.getElementById('pre-order-arrival-wrapper-' + sectionId);
      // If no explicit wrapper ID, fall back to the parent span.
      if (!wrapperEl && arrivalEl) {
        wrapperEl = arrivalEl.closest('.pre-order-badge__date');
      }

      if (arrivalEl) {
        if (arrivalDate) {
          arrivalEl.textContent = formatArrivalDate(arrivalDate);
          if (wrapperEl) wrapperEl.classList.remove('hide');
        } else {
          arrivalEl.textContent = '';
          if (wrapperEl) wrapperEl.classList.add('hide');
        }
      }
    });

    // Update add-to-cart button(s).
    document.querySelectorAll('[id^="addToCart-"]').forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span) return;

      if (backorder) {
        span.textContent = 'Pre-order';
        btn.removeAttribute('disabled');
        btn.dataset.action = 'add-to-cart';
      } else {
        var qty = window.product && window.product.inventory && window.product.inventory[variantId];
        var policy = window.product && window.product.policy && window.product.policy[variantId];
        var available = qty > 0 || policy === 'continue';

        if (available) {
          span.textContent = 'Add to cart';
          btn.removeAttribute('disabled');
          btn.dataset.action = 'add-to-cart';
        } else {
          span.textContent = 'Unavailable';
          btn.setAttribute('disabled', '');
          delete btn.dataset.action;
        }
      }
    });
  }

  // Haven variant picker fires this custom event.
  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail && e.detail.variant;
    if (variant && variant.id) {
      updatePreOrderUI(variant.id);
    }
  });

  // Standard/dropdown picker updates the hidden select[name="id"].
  document.querySelectorAll('select[name="id"]').forEach(function (select) {
    select.addEventListener('change', function () {
      var id = parseInt(this.value, 10);
      if (id) updatePreOrderUI(id);
    });
  });
})();
